import { endpoints } from './endpoints';

export const environment = {
  production: true,
  apiBaseUrl: 'https://gwt-qa1-1075186556091.europe-west2.run.app/',
  
  baseUrl: 'http://gwt-frontend-qa1.web.app',
  endpoints: endpoints,
};
